import { NctsCountry } from '../../../../config'
import { useDeclarationEditorContext } from '../contexts/DeclarationEditorContext'

function useDeclarationCountry(): NctsCountry | '' {
  const { editorData } = useDeclarationEditorContext()
  return editorData?.country ?? ''
}

export default useDeclarationCountry
